import React, { useMemo, useCallback } from 'react';

import { useSelector } from 'react-redux';

import picsioConfig from '../../../../../config';
import SearchFiltersToriut from './ToriutSearchFilters/index';
import SearchFilters from './SearchFilters';
import {
  navigate,
  isRouteProducts,
  setSearchRoute,
} from '../../helpers/history';
import TabsCatalog from '../TabsCatalog';
import { getDefaultProductLayerIds } from './helpers/productLayerFilter';

const tabsConfig = [
  { id: 'media', text: 'Media library' },
  { id: 'products', text: 'Products' },
];
const SearchFiltersContainer = ({ onlyTextSearch, searchFilters }) => {
  const location = useSelector((state) => state.router.location);
  const productLayerOptions = useSelector(
    (state) => state.user.availableSearchFilters?.products?.productLayer?.options,
  );

  const activeTab = useMemo(() => {
    if (location.pathname.startsWith('/products')) return tabsConfig[1].id;
    return tabsConfig[0].id;
  }, [location]);

  const isToriutMedia = useMemo(() => picsioConfig.isPim && !isRouteProducts(location.pathname), [location.pathname]);

  const handleChangeTab = useCallback((tabId) => {
    if (tabId === 'media') {
      navigate('/search');
    } else {
      setSearchRoute({
        productLayer: getDefaultProductLayerIds(productLayerOptions),
      }, { isProducts: true });
    }
  }, [productLayerOptions]);

  return (
    <>
      <If condition={!onlyTextSearch && picsioConfig.isPim && !location?.query?.inboxId}>
        <TabsCatalog
          list={tabsConfig}
          active={activeTab}
          onChange={handleChangeTab}
        />
      </If>
      <Choose>
        <When condition={isToriutMedia}>
          <SearchFiltersToriut onlyTextSearch={onlyTextSearch} />
        </When>
        <Otherwise>
          <SearchFilters
            onlyTextSearch={onlyTextSearch}
            searchFilters={searchFilters}
          />
        </Otherwise>
      </Choose>
    </>
  );
};

export default SearchFiltersContainer;
